import script from "./ace-editor.vue?vue&type=script&setup=true&lang=js"
export * from "./ace-editor.vue?vue&type=script&setup=true&lang=js"

import "./ace-editor.vue?vue&type=style&index=0&id=d0823ade&lang=scss&scoped=true"

import exportComponent from "D:\\code\\form_designer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0823ade"]])

export default __exports__